// src/modules/app-views/companies/pages/Init/components/tableColumns/contactsColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip } from 'antd';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function contactsColumn(buildColumnProps, options = {}) {
  const {
    key = 'contacts',
    title = 'contacts',
    dataIndex = 'email',
    width, // = 200,
    columnProps = {},
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    className: 'text-truncate text-transform-content-none',
    ...(buildColumnProps ? buildColumnProps(dataIndex, columnProps) : {}),
    render: (_, r) => {
      const email = r?.email?.value;
      const phone = r?.phone?.national || r?.phone?.value;

      if (!email && !phone) return '—';

      return (
        <div className="d-flex flex-column" style={{ gap: 2 }}>
          {email && (
            <Tooltip title={email}>
              <span className="text-truncate" style={{ maxWidth: 180 }}>
                <MailOutlined style={{ marginRight: 4, color: '#8c8c8c' }} />
                {email}
              </span>
            </Tooltip>
          )}
          {phone && (
            <span>
              <PhoneOutlined style={{ marginRight: 4, color: '#8c8c8c' }} />
              {phone}
            </span>
          )}
        </div>
      );
    },
  };
}

export default contactsColumn;
